// extracted by mini-css-extract-plugin
module.exports = {"advancedTextEditor":"_27L2FF0P","actionBar":"kl63pMU_","preview":"_3rVSBBHJ","suggestion":"UlxdDFQF","actions":"_2sgPShiC"};